export default "__VITE_ASSET__Bu5KuQtR__"